import Axios, {AxiosResponse} from 'axios';
import {GET_SERIES_EVENTS_URL, CREATE_EVENT_URL, DELETE_EVENT_URL, UPDATE_EVENT_URL, PORT} from "event-series-shared/src/constants";
import {EventResult} from "event-series-shared/src/types/EventResult";

export const hostName = process.env.REACT_APP_API_URL || 'http://localhost:' + PORT;

export const getEventSeries = async (seriesId: number): Promise<AxiosResponse<EventResult[]>> => {
    return Axios.post(hostName + GET_SERIES_EVENTS_URL, { seriesId });
}

export const createEvent = async (start: string, end: string, seriesId: number): Promise<AxiosResponse<{ok: boolean}>> => {
    return Axios.post(hostName + CREATE_EVENT_URL, { start, end, seriesId });
}

export const deleteEvent = async (eventId: number): Promise<AxiosResponse<{ok: boolean}>> => {
    return Axios.post(hostName + DELETE_EVENT_URL, { eventId });
}

export const updateEvent = async (eventId: number, start: string, end: string): Promise<AxiosResponse<{ok: boolean}>> => {
    return Axios.post(hostName + UPDATE_EVENT_URL, { eventId, start, end });
}
